import { Paper, Stack, Typography } from "@mui/material";
import {
  BooleanInput,
  Edit,
  ListButton,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { formatDateToStandard } from "@/fields/DateFieldWithStandardFormat/utils/formatDateToStandard";
import { CampaignTdsEdit } from "@/modules/campaignTds";
import { ClientAppInput } from "@/modules/clientApps";
import { DeviceTypeInput } from "@/modules/deviceTypes/components/DeviceTypeInput";
import { TrackerInput } from "@/modules/trackers";

import { TrafficSourceInput } from "../../trafficSources/components/TrafficSourceInput";
import { DEFAULT_CAMPAIGN_CLIENT_APP_ID } from "../constants";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const CampaignEdit = () => {
  return (
    <Edit actions={<EditActions />} mutationMode="pessimistic">
      <SimpleForm
        toolbar={<EditToolbar />}
        direction="column"
        gap={2}
        alignItems="stretch"
      >
        <Paper
          sx={{
            flex: 1,
            padding: 2,
            width: "100%",
          }}
          elevation={1}
          variant="outlined"
        >
          <TextInput
            source="createdAt"
            format={formatDateToStandard}
            readOnly
          />
          <TextInput
            source="updatedAt"
            format={formatDateToStandard}
            readOnly
          />
          <TextInput
            source="title"
            helperText="example: Best of The Best"
            validate={[required()]}
          />
          <DeviceTypeInput source="deviceTypeId" />
          <TrackerInput source="trackerId" validate={[required()]} />
          <TrafficSourceInput source="trafficSource" validate={[required()]} />
          <NumberInput
            source="campaignId"
            label="Campaign Id"
            defaultValue={0}
            validate={[required()]}
          />
          <ClientAppInput
            source="clientAppId"
            optionValue="id"
            defaultValue={DEFAULT_CAMPAIGN_CLIENT_APP_ID}
            validate={[required()]}
          />

          <Stack direction="column" spacing={2} width="100%">
            <Typography variant="h3" fontSize="16px">
              Install Postback Url
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <BooleanInput
                source="installPostbackUrlEnabled"
                label={false}
                defaultValue={false}
              />
              <TextInput
                fullWidth
                source="installPostbackUrl"
                defaultValue="http://swtchry.com/click.php?cnv_id={click_id}&payout=1.5"
              />
            </Stack>
          </Stack>

          <Stack direction="column" spacing={2} width="100%">
            <Typography variant="h3" fontSize="16px">
              Trial Postback Url
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <BooleanInput
                source="trialPostbackUrlEnabled"
                label={false}
                defaultValue={false}
              />
              <TextInput
                fullWidth
                source="trialPostbackUrl"
                defaultValue="http://swtchry.com/click.php?cnv_id={click_id}&payout=1.5"
              />
            </Stack>
          </Stack>

          <Stack direction="column" spacing={2} width="100%">
            <Typography variant="h3" fontSize="16px">
              Subscription Postback Url
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <BooleanInput
                source="subscriptionPostbackUrlEnabled"
                label={false}
                defaultValue={false}
              />
              <TextInput
                fullWidth
                source="subscriptionPostbackUrl"
                defaultValue="http://swtchry.com/click.php?cnv_id={click_id}&payout=1.5"
              />
            </Stack>
          </Stack>

          <BooleanInput source="active" defaultValue={true} />
        </Paper>

        <Paper
          sx={{
            flex: 1,
            padding: 2,
            width: "100%",
          }}
          elevation={1}
          variant="outlined"
        >
          <CampaignTdsEdit />
        </Paper>
      </SimpleForm>
    </Edit>
  );
};
